/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import * as Styles from '../../../Maintain/client/Components/StyleConstant';
import {
  amountComparator,
  cellRenderer,
  comparatorQtr,
} from '../../../../SharedModules/utilities/utilities';

const CalculatedInterestDetailsQuarterTable = ({
  fullScreen,
  setFullScreen,
  reportData,
}) => {
  const MAN_HEAD = [
    {
      headerName: 'Detail Level',
      field: 'detailLevel',
      editable: false,
      minWidth: 160,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      excelAlignment: 'right',
      dataAlignRight: true,
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'QTR',
      field: 'qtr',
      minWidth: 160,
      maxLength: Styles.Length_255,
      comparator: comparatorQtr,
      wrapText: true,
      autoHeight: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      editable: false,
      cellStyle: {
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Total QTR Interest',
      field: 'totalQtrInterest',
      minWidth: 230,
      editable: false,
      maxLength: Styles.Length_255,
      wrapText: true,
      autoHeight: true,
      comparator: amountComparator,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      excelAlignment: 'right',
      exportZeroesTwo: true,
      cellRenderer: cellRenderer,
      dataAlignRight: true,
      isTextColorRed: true,
      cellStyle: {
        textAlign: 'right',
        'border-right-color': Styles.BorderColor,
      },
      sortingOrder: ['desc', 'asc'],
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },

      exportOption: {
        printWithCurrency: '$',
      },
    },
  ];

  const [tableCount, setTableCount] = useState(0);
  const [gridApi, setGridApi] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
  }, []);
  useEffect(() => {
    resetFilters();
    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi]);

  const resetFilters = () => {
    gridApi && gridApi.setFilterModel(null);
  };
  const [applyFilter, setApplyFilter] = useState(false);
  const onSelectionChanged = useCallback(() => {
    setSelectedRow(gridApi.getSelectedRows());
  }, [gridApi]);
  const handleFullScreenView = () => {
    setFullScreen(!fullScreen);
  };
  const createData = (count) => {
    const result = [];
    let totalInterest=0;
    reportData.map((dt)=>{
      totalInterest=totalInterest+parseFloat(dt?.totalQtrInterest)
    })
    for (let i = 0; i < count; i += 1) {
      result.push({
        detailLevel:'',
        qtr:'Total',
        totalQtrInterest:totalInterest,
        isBottomRow: true,
      });
    }
    return result;
  };

  const pinnedBottomRowData = useMemo(() => {
    if(Array.isArray(reportData)&&reportData?.length>0&&reportData?.[reportData?.length-1]?.qtr!=='Total'){

      return createData(1);
    }
    }, [reportData]);
  return (
    <div className="tabs-container tBillPanel custom-check">
      <div className="table-container p-0 eightRecords col-12 no-border">
        <TableGridWithFeatures
          data-testid="CAL-MFG-table"
          fullScreenView={fullScreen}
          handleFullScreenViewClick={handleFullScreenView}
          gridHeight={fullScreen ? '100vh' : 350}
          onGridReady={onGridReady}
          rowData={reportData}
          columnDefs={MAN_HEAD}
          exportFile
          sideBar={false}
          onFilterChanged={(e) => {
            setTableCount(e.api.getDisplayedRowCount());
            if (
              (e.api.getFilterModel() && Object.keys(e.api.getFilterModel()))
                .length > 0
            ) {
              setApplyFilter(true);
            } else {
              setApplyFilter(false);
            }
          }}
          singleClickEdit={false}
          fileName="Calc Interest Details - Quarter"
          onSelectionChanged={onSelectionChanged}
          pinnedBottomRowData={pinnedBottomRowData}
        />
      </div>
    </div>
  );
};
export default CalculatedInterestDetailsQuarterTable;
